import { Component, EventEmitter, Input } from '@angular/core';
import { isNullOrUndefined } from '@uzurv/core';
import { GenericListButtonClickHandlerData } from './generic-list-button-click-handler-data';

@Component({
  selector: 'app-generic-list-button',
  templateUrl: './generic-list-button.component.html',
  styleUrls: ['./generic-list-button.component.scss']
})
export class GenericListButtonComponent {
  @Input()
  testingId = null;

  @Input()
  buttonColor = 'primary';

  @Input()
  buttonTitle: string;

  @Input()
  data: any;

  @Input()
  clickHandler: EventEmitter<GenericListButtonClickHandlerData>;

  @Input()
  disabled = false;

  handleClick(event: MouseEvent) {
    if (!isNullOrUndefined(this.clickHandler)) {
      this.clickHandler.emit({ data: this.data, clickEvent: event });
    }
  }
}
